import { IBag, IBagApi } from '@@/bags/ts';

export function bagMapper({
  id,
  agriculture_id,
  filling_date,
  values,
  warehouse_id,
  weight,
  position,
  reserved_weight,
  description,
  custom_name,
}: IBagApi): IBag {
  return {
    id,
    values,
    weight,
    reservedWeight: reserved_weight,
    fillingDate: filling_date,
    warehouseId: warehouse_id,
    agricultureId: agriculture_id,
    position: JSON.parse(position ?? '[]'),
    description: description,
    customName: custom_name,
  };
}
